module.exports = __webpack_public_path__ + "img/feishu.85b869d5.png";